var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "commonHeader" } }, [
    _c("div", { staticClass: "text", on: { click: _vm.to } }, [
      _vm.$route.name === "RepayMethod"
        ? _c("p", { staticClass: "textDown" }, [
            _vm._v(" After downloading the APP, "),
            _c("br"),
            _vm._v(" you only need to repay "),
            _c("span", [_vm._v("₱ " + _vm._s(_vm.amount))]),
          ])
        : _c("p", { staticClass: "textDown" }, [
            _c("span", [_vm._v("Download")]),
            _vm._v(" the app and "),
            _c("br"),
            _vm._v(" get your "),
            _c("span", [_vm._v("2nd")]),
            _vm._v(" installment "),
            _c("span", [_vm._v("waived.")]),
          ]),
    ]),
    _c("div", { staticClass: "right breathe", on: { click: _vm.to } }, [
      _vm.showTime
        ? _c("div", { staticClass: "time" }, [
            _c("p", [_vm._v(_vm._s(_vm.formattedTime))]),
          ])
        : _vm._e(),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "addBtn" }, [_c("p", [_vm._v("Get APP")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }